import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import Modal from 'react-responsive-modal'
import { getRecaptcha, hideRecaptcha, RecaptchaPayload } from '../../common/slice'
import { useAppDispatch, useAppSelector } from '../../common/store'
import { PayloadAction } from '../../common/types'
import { RECAPTCHA_V2_PUBLIC_SITE_KEY } from '../../environment'

import './VctRecaptcha.css'

/**
 * Uses react-google-recaptcha, a React wrapper library for Googles ReCAPTCHA v2
 *
 * This component is rendered only when the 'renderCaptcha' property is set in the applications redux store
 * The recapture is rendered in a modal dialog with the help of the 'react-responsive-modal'
 */
function VctRecaptcha() {
  const recaptchaRef = React.createRef<ReCAPTCHA>()
  const recaptcha = useAppSelector(getRecaptcha)
  const dispatch = useAppDispatch()

  const onCloseModal = () => {
    dispatch(hideRecaptcha())
  }

  const onCaptchaComplete = (action: PayloadAction<RecaptchaPayload>, recaptchaV2Code: string) => {
    dispatch(hideRecaptcha())
    action.payload.recaptchaV2Code = recaptchaV2Code
    dispatch(action)
  }

  const onCaptchaChange = (value: string | null) => {
    onCloseModal()
    recaptchaRef.current?.reset()
    if (recaptcha.action && value) {
      onCaptchaComplete(recaptcha.action, value)
    }
  }

  return (
    <React.Fragment>

      <Modal open={recaptcha.renderCaptcha} onClose={onCloseModal} showCloseIcon={false} focusTrapped={true}
             blockScroll={true} center>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={RECAPTCHA_V2_PUBLIC_SITE_KEY}
          onChange={onCaptchaChange}
        />
      </Modal>

    </React.Fragment>
  )
}

export default VctRecaptcha